import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { WsApiService }             from './ws-api.service';
import { WsApiSettingsComponent }   from './ws-api.settings.component';
import { WsApiSettingsModel }       from './typings/ws-api.settings.model';

export const WsApiStates : Array<NgHybridStateDeclaration> = [
  {
    component: WsApiSettingsComponent,
    name     : 'app.ws-api-settings',
    resolve  : [
      {
        deps     : [ WsApiService ],
        resolveFn: ( wsApiService : WsApiService ) : Promise<CompanyIntegrationsModel> => wsApiService.getIntegrations(),
        token    : 'integrations'
      },
      {
        deps     : [ 'integrations', WsApiService ],
        resolveFn: ( integrations : CompanyIntegrationsModel, wsApiService : WsApiService, ) : Promise<WsApiSettingsModel> => integrations.has_workshop_api
          ? wsApiService.getSettings()
          : Promise.resolve({} as WsApiSettingsModel),
        token: 'settings'
      }
    ],
    url: '/ws-api-settings'
  }
];
